import { render, staticRenderFns } from "./ResultsTableView.vue?vue&type=template&id=2a6b1866&scoped=true"
import script from "./ResultsTableView.vue?vue&type=script&lang=js"
export * from "./ResultsTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b1866",
  null
  
)

export default component.exports